/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ListMembersRole } from './listMembersRole';
import type { ListMembersRoleNot } from './listMembersRoleNot';
import type { ListMembersStatus } from './listMembersStatus';
import type { ListMembersStatusNot } from './listMembersStatusNot';

export type ListMembersParams = {
/**
 * @maxLength 200
 */
search?: string;
role?: ListMembersRole;
role_not?: ListMembersRoleNot;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
per_page?: number;
include_suspended?: boolean;
status?: ListMembersStatus;
status_not?: ListMembersStatusNot;
ids?: string[] | null;
};
